import { cn } from '@magicschool/spellbook/lib/utils';
import { Slot as RadixSlot } from '@radix-ui/react-slot';
import { Slot } from '../Slot';

export const CardHeaderSlot = Slot<React.ComponentProps<'div'>>({
  displayName: 'Card.Header',
  renderDefault: ({ className, ...props }) => {
    return <div data-spellbook-name="card-header" className={cn('w-full', className)} {...props} />;
  },
});

export const CardContentSlot = Slot<React.ComponentProps<'div'>>({
  displayName: 'Card.Content',
  renderDefault: (props) => {
    return <div data-spellbook-name="card-content" {...props} />;
  },
});

export const CardFooterSlot = Slot<React.ComponentProps<'div'>>({
  displayName: 'Card.Footer',
  renderDefault: ({ className, ...props }) => {
    return <div data-spellbook-name="card-footer" className={cn('w-full flex flex-row-reverse items-center', className)} {...props} />;
  },
});

type CardTriggerProps = React.ComponentProps<'a'> & {
  asChild?: boolean;
};

export const CardTriggerSlot = Slot<CardTriggerProps>({
  displayName: 'Card.Trigger',
  renderDefault: ({ asChild, className, ...props }: CardTriggerProps) => {
    const Comp = asChild ? RadixSlot : 'a';
    return (
      <Comp
        data-spellbook-name="card-trigger"
        className={cn('w-full cursor-pointer', 'after:absolute after:inset-0 after:rounded-card-md', className)}
        {...props}
      />
    );
  },
});
